(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-badges"] && !Shopify.designMode) return;
  try {
    window.addEventListener('variantChangeEnd', () => {
    document.querySelectorAll('.jb-badges[data-variant-badges]').forEach((wrap) => {
      const input = document.querySelector(`#product-form-${wrap.dataset.sectionId} input[name="id"]`);
      if (!input) return;
      wrap.querySelectorAll('[data-variant-id]').forEach((badge) => {
        badge.hidden = badge.dataset.variantId !== input.value;
      });
    });
  });
  } catch(e) { console.error(e); }
})();

})();
